import { ITerminationReason } from 'APIPackage/CatalogsModule/interfaces/ITerminationReason';

import { ITerminationReasonSelectOption } from '../interfaces/ITerminationReasonSelectOption';

export const createTerminationReasonSelectOption = (country: ITerminationReason): ITerminationReasonSelectOption => ({
  ...country,
  label: country.name,
  value: country.id,
});
